import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "./../../../utils/flash/index";
import chargesService from "./chargesService";

const initialState = {
  all_charges: [],
  single_charge: null,
  unpaginated_charges: [],
  isLoading: false,
  isSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  isUpdating: false,
  isError: false,
};

const chargesSlice = createSlice({
  initialState,
  name: "charges",
  reducers: {
    resetCharge: (state) => initialState,
    resetChargeStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.single_charge = null;
      state.createSuccess = false;
      state.updateSuccess = false;
      state.isFetching = false;
    },
    resetUpdateCharge: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCharge.pending, (state) => {
        state.isLoading = true;
        flash("info", "Charge is creating...");
      })
      .addCase(createCharge.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.createSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(createCharge.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(updateCharge.pending, (state) => {
        state.isLoading = true;
        flash("info", "Charge is updating...");
      })
      .addCase(updateCharge.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.updateSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateCharge.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getAllCharges.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCharges.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isSuccess = true;
          state.all_charges = payload;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getAllCharges.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getUnpaginatedCharges.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnpaginatedCharges.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.unpaginated_charges = payload;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getUnpaginatedCharges.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getSingleCharge.pending, (state) => {
        state.isLoading = true;
        state.single_charge = null;
      })
      .addCase(getSingleCharge.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isSuccess = true;
          state.single_charge = payload.edit_charge_data;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getSingleCharge.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const createCharge = createAsyncThunk(
  "/charge/create",
  async (data, thunkAPI) => {
    try {
      return await chargesService.createCharge(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllCharges = createAsyncThunk(
  "/charge/getAll",
  async (pageNum, thunkAPI) => {
    try {
      return await chargesService.getAllCharges(pageNum);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getUnpaginatedCharges = createAsyncThunk(
  "/charge/getUnpaginated",
  async (_, thunkAPI) => {
    try {
      return await chargesService.getUnpaginatedCharges();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSingleCharge = createAsyncThunk(
  "/charge/getSingle",
  async (id, thunkAPI) => {
    try {
      return await chargesService.getSingleCharge(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateCharge = createAsyncThunk(
  "/charge/update",
  async (id, thunkAPI) => {
    try {
      return await chargesService.updateCharge(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetCharge, resetChargeStatus, resetUpdateCharge } =
  chargesSlice.actions;
export default chargesSlice.reducer;
